export enum EventStages {
  REGISTRATION = 'REGISTRATION',
  PRESHOW = 'PRESHOW',
  COUNTDOWN = 'COUNTDOWN',
  LIVESTREAM = 'LIVESTREAM',
  LIVESTREAMENDING = 'LIVESTREAMENDING',
  POSTLIVESTREAM = 'POSTLIVESTREAM',
  POSTSHOW = 'POSTSHOW',
  POSTEVENT = 'POSTEVENT'
}

export enum Environments {
  dev = 'dev',
  local = 'local',
  prod = 'prod',
  staging = 'staging',
  qa = 'dev'
}

export const defaultEventConfigs: { [key: string]: EventConfig } = {
  prod: {
    id: '1',
    useBackupStream: false
  },
  staging: {
    id: '2',
    useBackupStream: false
  },
  dev: {
    id: '3',
    useBackupStream: false
  },
  local: {
    id: '4',
    useBackupStream: false
  }
}

export interface EventConfig {
  id: string
  stage?: EventStages
  useBackupStream?: boolean
  streamStartTime?: string
}
